export default __webpack_public_path__ + "static/media/Version (2) - LOTR_06.db1b9053.jpg";